import { Injectable } from "@angular/core";
import {
  NotificationMessageIcon,
  RetryServices,
} from "@app/framework/notification-sidebar/notification-sidebar.component";
import { environment } from "@env/environment";
import { HttpUtilService } from "./http-util.service";
import { NotificationsService } from "./notifications.service";
import { WebsocketService } from "./websocket.service";
import { TranslationService } from "./translation.service";

export class CourseImportRequest {
  lmsConfig: string;
  courseId: string;
  target?: string;
  id: string;
}
@Injectable({
  providedIn: "root",
})
export class CourseImportService {
  private updateSocket;
  private socketConnectionId;
  private coursesToImport = [];

  constructor(
    private httpUtils: HttpUtilService,
    private socketService: WebsocketService,
    private notification: NotificationsService,
    private translationService:TranslationService
  ) {}

  import(request: CourseImportRequest) {
    if (this.coursesToImport.includes(request.id + request.courseId)) return;
    
    this.notification.addUserNotification(
      {
        icon:NotificationMessageIcon.fileExport,
        text: `${this.translationService.getTranslatedContent('importing',"Importing")} <b>${request.courseId}:${request.lmsConfig}</b>`,
        shouldForceOpen: true,
        preventRemoval: true,
        status: `${this.translationService.getTranslatedContent('in_progress',"In Progress")}`,
      },
      request.id
    );

    let course;
    this.coursesToImport.push(request.id + request.courseId);

    this.updateSocket = this.socketService.createSocket();

    this.updateSocket.onopen = () => {
      this.updateSocket.send(
        JSON.stringify({
          action: "setlistener",
          data: {
            type: "courseImport",
            "user-pool-id": environment.cognitoUserPoolId,
            "client-id": environment.cognitoClientId,
            "sub-domain": environment.domain,
          },
        })
      );
    };

    this.updateSocket.onmessage = (event) => {
      const data = event.data.replace(/'/g, '"');
      const message = JSON.parse(data);
      if (message["Status"] == "Listener set.") {
        this.socketConnectionId = message["Connection"];
      } else if (message["Update"]) {
        if (message["Update"] == "Course Created.") {
          course = message["courseId"];

          
          this.notification.addUserNotification(
            {icon:NotificationMessageIcon.checkmark,
              text: `${this.translationService.getTranslatedContent("importing","Importing")} <b>${request.courseId}:${request.lmsConfig}</b> complete`,
              link: {
                href: `/courses/${course}`,
                text: "View Course",
              },
              status: this.translationService.getTranslatedContent("import_complete",`Import Complete`),
            },
            request.id
          );

          this.handleClose(request);
        } else if (message["Update"] == "Course not found.") {
          this.handleClose(request);

          this.notification.addUserNotification(
            {
              icon:NotificationMessageIcon.fail,
              text: `${this.translationService.getTranslatedContent("importing","Importing")} <b>${request.courseId}:${request.lmsConfig}</b> ${this.translationService.getTranslatedContent("failed","failed")}. ${this.translationService.getTranslatedContent("unable_to_find_a_course_with_that_id","Unable to find a course with that id")}`,

              status: this.translationService.getTranslatedContent("import_failed",`Import Failed`),
            },
            request.id
          );
        } else if (message["Update"] == "Import Failed") {
          this.handleClose(request);

          this.notification.addUserNotification(
            {
              icon:NotificationMessageIcon.fail,
              text: `${this.translationService.getTranslatedContent("importing","Importing")} <b>${request.courseId}:${request.lmsConfig}</b> ${this.translationService.getTranslatedContent("failed","failed")}.`,
              retry: {
                service: RetryServices.courseImport,
                data: request,
              },
              status: this.translationService.getTranslatedContent("import_failed",`Import Failed`),
            },
            request.id
          );
        } else if (message["Update"] == "Update finished.") {
          this.handleClose(request);
          this.notification.addUserNotification(
            {
              icon:NotificationMessageIcon.checkmark,
              text: `${this.translationService.getTranslatedContent('importing',"Importing")} <b>${request.courseId}:${request.lmsConfig}</b> ${this.translationService.getTranslatedContent('complete',"Complete")}`,

              status:this.translationService.getTranslatedContent("import_update_complete",`Import Update Complete`),
            },
            request.id
          );
        } else {
          this.handleClose(request);
          this.notification.addUserNotification(
            {
              icon:NotificationMessageIcon.checkmark,
              text: `${this.translationService.getTranslatedContent('importing',"Importing")} <b>${request.courseId}:${request.lmsConfig}</b> ${this.translationService.getTranslatedContent('complete',"Complete")}`,
              link: {
                href: `/courses/${course}`,
                text: "View Course",
              },
              status: this.translationService.getTranslatedContent("import_complete",`Import Complete`),
            },
            request.id
          );
        }
      }
    };

    this.httpUtils
      .request(
        "POST",
        environment.apiRoot + "/import/course",
        request,
        null,
        true
      )
      .subscribe((data) => {});
  }

  handleClose(request: CourseImportRequest) {
    this.coursesToImport.splice(
      this.coursesToImport.indexOf(request.id + request.courseId),
      1
    );
    this.updateSocket.close();
  }
}
